module.exports = __webpack_public_path__ + "static/media/ellipsis.5ad10bf4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Roller/ellipsis.svg
// module id = 52
// module chunks = 0